import React, { Component } from 'react';
import ScrollFadeIn from './../../components/scrollFadeIn';
import {Colors} from './../../utils/constants';
import DesignSection from './designSection';
import SectionBanner from './sectionBanner';
import SectionPageHeader from './sectionPageHeader';

export default class SigmaSection extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div className="full-width sectionContainer">
        <SectionBanner image="/images/background-lines-gradient-purple.webp" title="Sigma" />
        <SectionPageHeader description="Sigma is a tool for building client-facing dashboards, and how we design within it directly impacts the client experience. Following these best practices ensures our dashboards are clear, accessible, and on-brand." />
        <div className="max-width-container">
          <div className="medium-top-margin">
            <h2 className="small-padding" style={{paddingBottom:0, paddingTop:0}}>{'Sigma Design Best Practices'}</h2>
            <div className="max-width-container small-padding no-bottom-padding">
              <h4 className="dark-grey-color">{"Recommended Page Layout "}</h4>
                <p className="subheading tiny-top-margin">
                {"Refrain from including an abundance of content on a single page that intends to fulfill multiple purposes. Our clients ability to use the dashboard partly depends on their available brain capacity (cognitive load). The more content and options we put in front of them the less likely they are to complete any tasks."}
              </p>
            </div>
          </div>
          <div className="small-padding">
            <div className="medium-padding no-top-padding no-bottom-padding">
              <ScrollFadeIn>
                <div className="tiny-padding" style={{border: "2px solid #4CAF50", borderRadius: '8px', overflow: 'hidden', maxWidth: '800px'}}>
                  <img src={'/design/rules-sigma-recommended-page-layout.png'} className="full-width" />
                </div>
              </ScrollFadeIn>
            </div>
          </div>
          <div className="medium-top-margin">
            <div className="max-width-container small-padding no-bottom-padding">
              <h4 className="dark-grey-color">{"Landing Page"}</h4>
                <p className="subheading tiny-top-margin">
                {"The landing page should engage and encourage users to interact with the dashboard, making a positive first impression that reflects the value of the dashboard. Ensure the landing page is a quick overview or answers the most important question our clients ask. Refrain from making documentation (like methodology) the landing page of the dashboard."}
              </p>
            </div>
            <ScrollFadeIn>
                  <div className="row">
                    <div
                      className="small-12 medium-6 full-height small-padding">
                      <div className="tiny-padding" style={{border: "2px solid #4CAF50", borderRadius: '8px', overflow: 'hidden'}}>
                        <img src={'/design/rules-sigma-landing-page-do.png'} className="full-width" />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '6px', marginTop: '8px' }}>
                        <span className="material-symbols-rounded" style={{ color: '#4CAF50', fontSize: '18px', marginTop: '2px', fontVariationSettings: "'FILL' 1" }}>check_circle</span>
                        <p style={{ margin: 0, fontSize: '0.85rem', color: '#4CAF50', opacity: 1 }}>{'Do'}</p>
                      </div>
                    </div>
                    <div
                      className="small-12 medium-6 full-height small-padding">
                      <div className="tiny-padding" style={{border: "2px solid #ED4843", borderRadius: '8px', overflow: 'hidden'}}>
                        <img src={'/design/rules-sigma-landing-page-dont.png'} className="full-width" />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '6px', marginTop: '8px' }}>
                        <span className="material-symbols-rounded" style={{ color: '#ED4843', fontSize: '18px', marginTop: '2px', fontVariationSettings: "'FILL' 1" }}>cancel</span>
                        <p style={{ margin: 0, fontSize: '0.85rem', color: '#ED4843', opacity: 1 }}>{"Don't"}</p>
                      </div>
                    </div>
                  </div>
            </ScrollFadeIn>
          </div>
          <div className="medium-top-margin">
            <div className="max-width-container small-padding no-bottom-padding">
              <h4 className="dark-grey-color"><span className="primary-color">{"Guideline 1: "}</span>{'Filter Element Position'}</h4>
                <p className="subheading tiny-top-margin">
                {"Position filters and other control elements on top of the page"}
              </p>
            </div>
            <ScrollFadeIn>
                  <div className="row">
                    <div
                      className="small-12 medium-6 full-height small-padding">
                      <div className="tiny-padding" style={{border: "2px solid #4CAF50", borderRadius: '8px', overflow: 'hidden'}}>
                        <img src={'/design/rules-sigma-1-do.png'} className="full-width" />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '6px', marginTop: '8px' }}>
                        <span className="material-symbols-rounded" style={{ color: '#4CAF50', fontSize: '18px', marginTop: '2px', fontVariationSettings: "'FILL' 1" }}>check_circle</span>
                        <p style={{ margin: 0, fontSize: '0.85rem', color: '#4CAF50', opacity: 1 }}>{'Do'}</p>
                      </div>
                    </div>
                    <div
                      className="small-12 medium-6 full-height small-padding">
                      <div className="tiny-padding" style={{border: "2px solid #ED4843", borderRadius: '8px', overflow: 'hidden'}}>
                        <img src={'/design/rules-sigma-1-dont.png'} className="full-width" />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '6px', marginTop: '8px' }}>
                        <span className="material-symbols-rounded" style={{ color: '#ED4843', fontSize: '18px', marginTop: '2px', fontVariationSettings: "'FILL' 1" }}>cancel</span>
                        <p style={{ margin: 0, fontSize: '0.85rem', color: '#ED4843', opacity: 1 }}>{"Don't"}</p>
                      </div>
                    </div>
                  </div>
            </ScrollFadeIn>
          </div>
          <div className="medium-top-margin">
            <div className="max-width-container small-padding no-bottom-padding">
              <h4 className="dark-grey-color"><span className="primary-color">{"Guideline 2: "}</span>{'Chart Specific Filter Element Position'}</h4>
                <p className="subheading tiny-top-margin">
                {"Filters impacting a single visual may be positioned below the title and aligned to the left"}
              </p>
            </div>
            <ScrollFadeIn>
                  <div className="row">
                    <div
                      className="small-12 medium-6 full-height small-padding">
                      <div className="tiny-padding" style={{border: "2px solid #4CAF50", borderRadius: '8px', overflow: 'hidden'}}>
                        <img src={'/design/rules-sigma-2-do.png'} className="full-width" />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '6px', marginTop: '8px' }}>
                        <span className="material-symbols-rounded" style={{ color: '#4CAF50', fontSize: '18px', marginTop: '2px', fontVariationSettings: "'FILL' 1" }}>check_circle</span>
                        <p style={{ margin: 0, fontSize: '0.85rem', color: '#4CAF50', opacity: 1 }}>{'Do'}</p>
                      </div>
                    </div>
                    <div
                      className="small-12 medium-6 full-height small-padding">
                      <div className="tiny-padding" style={{border: "2px solid #ED4843", borderRadius: '8px', overflow: 'hidden'}}>
                        <img src={'/design/rules-sigma-2-dont.png'} className="full-width" />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '6px', marginTop: '8px' }}>
                        <span className="material-symbols-rounded" style={{ color: '#ED4843', fontSize: '18px', marginTop: '2px', fontVariationSettings: "'FILL' 1" }}>cancel</span>
                        <p style={{ margin: 0, fontSize: '0.85rem', color: '#ED4843', opacity: 1 }}>{"Don't"}</p>
                      </div>
                    </div>
                  </div>
            </ScrollFadeIn>
          </div>
          <div className="medium-top-margin">
            <div className="max-width-container small-padding no-bottom-padding">
              <h4 className="dark-grey-color"><span className="primary-color">{"Guideline 3: "}</span>{'Default Values'}</h4>
                <p className="subheading tiny-top-margin">
                {"Always set default filter values."}
              </p>
            </div>
            <ScrollFadeIn>
                  <div className="row">
                    <div
                      className="small-12 medium-6 full-height small-padding">
                      <div className="tiny-padding" style={{border: "2px solid #4CAF50", borderRadius: '8px', overflow: 'hidden'}}>
                        <img src={'/design/rules-sigma-4-do.png'} className="full-width" />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '6px', marginTop: '8px' }}>
                        <span className="material-symbols-rounded" style={{ color: '#4CAF50', fontSize: '18px', marginTop: '2px', fontVariationSettings: "'FILL' 1" }}>check_circle</span>
                        <p style={{ margin: 0, fontSize: '0.85rem', color: '#4CAF50', opacity: 1 }}>{'Do'}</p>
                      </div>
                    </div>
                    <div
                      className="small-12 medium-6 full-height small-padding">
                      <div className="tiny-padding" style={{border: "2px solid #ED4843", borderRadius: '8px', overflow: 'hidden'}}>
                        <img src={'/design/rules-sigma-4-dont.png'} className="full-width" />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '6px', marginTop: '8px' }}>
                        <span className="material-symbols-rounded" style={{ color: '#ED4843', fontSize: '18px', marginTop: '2px', fontVariationSettings: "'FILL' 1" }}>cancel</span>
                        <p style={{ margin: 0, fontSize: '0.85rem', color: '#ED4843', opacity: 1 }}>{"Don't"}</p>
                      </div>
                    </div>
                  </div>
            </ScrollFadeIn>
          </div>
          <div className="medium-top-margin">
            <div className="max-width-container small-padding no-bottom-padding">
              <h4 className="dark-grey-color"><span className="primary-color">{"Guideline 4: "}</span>{'Legend Placement'}</h4>
                <p className="subheading tiny-top-margin">
                {"Legend placement should be at the bottom of the chart"}
              </p>
            </div>
            <ScrollFadeIn>
                  <div className="row">
                    <div
                      className="small-12 medium-6 full-height small-padding">
                      <div className="tiny-padding" style={{border: "2px solid #4CAF50", borderRadius: '8px', overflow: 'hidden'}}>
                        <img src={'/design/rules-sigma-5-do.png'} className="full-width" />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '6px', marginTop: '8px' }}>
                        <span className="material-symbols-rounded" style={{ color: '#4CAF50', fontSize: '18px', marginTop: '2px', fontVariationSettings: "'FILL' 1" }}>check_circle</span>
                        <p style={{ margin: 0, fontSize: '0.85rem', color: '#4CAF50', opacity: 1 }}>{'Do'}</p>
                      </div>
                    </div>
                    <div
                      className="small-12 medium-6 full-height small-padding">
                      <div className="tiny-padding" style={{border: "2px solid #ED4843", borderRadius: '8px', overflow: 'hidden'}}>
                        <img src={'/design/rules-sigma-5-dont.png'} className="full-width" />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '6px', marginTop: '8px' }}>
                        <span className="material-symbols-rounded" style={{ color: '#ED4843', fontSize: '18px', marginTop: '2px', fontVariationSettings: "'FILL' 1" }}>cancel</span>
                        <p style={{ margin: 0, fontSize: '0.85rem', color: '#ED4843', opacity: 1 }}>{"Don't"}</p>
                      </div>
                    </div>
                  </div>
            </ScrollFadeIn>
          </div>
          <div className="medium-top-margin">
            <div className="max-width-container small-padding no-bottom-padding">
              <h4 className="dark-grey-color"><span className="primary-color">{"Guideline 5: "}</span>{'Sidebar Navigation'}</h4>
                <p className="subheading tiny-top-margin">
                {"Use sidebar to navigate between workbook and pages instead of buttons"}
              </p>
            </div>
            <ScrollFadeIn>
                  <div className="row">
                    <div
                      className="small-12 medium-6 full-height small-padding">
                      <div className="tiny-padding" style={{border: "2px solid #4CAF50", borderRadius: '8px', overflow: 'hidden'}}>
                        <img src={'/design/rules-sigma-9-do.png'} className="full-width" />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '6px', marginTop: '8px' }}>
                        <span className="material-symbols-rounded" style={{ color: '#4CAF50', fontSize: '18px', marginTop: '2px', fontVariationSettings: "'FILL' 1" }}>check_circle</span>
                        <p style={{ margin: 0, fontSize: '0.85rem', color: '#4CAF50', opacity: 1 }}>{'Do'}</p>
                      </div>
                    </div>
                    <div
                      className="small-12 medium-6 full-height small-padding">
                      <div className="tiny-padding" style={{border: "2px solid #ED4843", borderRadius: '8px', overflow: 'hidden'}}>
                        <img src={'/design/rules-sigma-9-dont.png'} className="full-width" />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '6px', marginTop: '8px' }}>
                        <span className="material-symbols-rounded" style={{ color: '#ED4843', fontSize: '18px', marginTop: '2px', fontVariationSettings: "'FILL' 1" }}>cancel</span>
                        <p style={{ margin: 0, fontSize: '0.85rem', color: '#ED4843', opacity: 1 }}>{"Don't"}</p>
                      </div>
                    </div>
                  </div>
            </ScrollFadeIn>
          </div>
          <div className="medium-top-margin medium-bottom-margin">
            <div className="max-width-container small-padding no-bottom-padding">
              <h4 className="dark-grey-color"><span className="primary-color">{"Guideline 6: "}</span>{'Card Settings'}</h4>
                <p className="subheading tiny-top-margin">
                {"Disable show cards so that the background is consistent across all dashboards"}
              </p>
            </div>
            <ScrollFadeIn>
                  <div className="row">
                    <div
                      className="small-12 medium-6 full-height small-padding">
                      <div className="tiny-padding" style={{border: "2px solid #4CAF50", borderRadius: '8px', overflow: 'hidden'}}>
                        <img src={'/design/rules-sigma-10-do.png'} className="full-width" />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '6px', marginTop: '8px' }}>
                        <span className="material-symbols-rounded" style={{ color: '#4CAF50', fontSize: '18px', marginTop: '2px', fontVariationSettings: "'FILL' 1" }}>check_circle</span>
                        <p style={{ margin: 0, fontSize: '0.85rem', color: '#4CAF50', opacity: 1 }}>{'Do'}</p>
                      </div>
                    </div>
                    <div
                      className="small-12 medium-6 full-height small-padding">
                      <div className="tiny-padding" style={{border: "2px solid #ED4843", borderRadius: '8px', overflow: 'hidden'}}>
                        <img src={'/design/rules-sigma-10-dont.png'} className="full-width" />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '6px', marginTop: '8px' }}>
                        <span className="material-symbols-rounded" style={{ color: '#ED4843', fontSize: '18px', marginTop: '2px', fontVariationSettings: "'FILL' 1" }}>cancel</span>
                        <p style={{ margin: 0, fontSize: '0.85rem', color: '#ED4843', opacity: 1 }}>{"Don't"}</p>
                      </div>
                    </div>
                  </div>
            </ScrollFadeIn>
          </div>

        </div>
      </div>
    );
  }
}
